import { IconSearch } from "@tabler/icons-react";
import { Card, Group, Heading, Input, Select, Stack, Text } from "@/components/ui";
import { BotonExportCambiosCsv } from "./BotonExportCambiosCsv";

/**
 * Filtros del scope cambios + botón exportar CSV. Todos los filtros se
 * resuelven en el SERVIDOR (el texto con debounce en la sección). Cuando el
 * scope tiene una sola categoría (e.g. "Acceso"), el dropdown queda
 * deshabilitado y el botón de export se habilita automáticamente.
 */
export function CambiosFiltrosCard({
  categoriasScope,
  categoria,
  onCategoriaChange,
  accion,
  onAccionChange,
  accionesDisponibles,
  texto,
  onTextoChange,
  total,
  desde,
  hasta,
  filtroCategoriaBackend,
}: {
  categoriasScope: readonly string[];
  categoria: string;
  onCategoriaChange: (c: string) => void;
  accion: string;
  onAccionChange: (a: string) => void;
  accionesDisponibles: string[];
  texto: string;
  onTextoChange: (t: string) => void;
  total: number;
  desde: number;
  hasta: number;
  filtroCategoriaBackend: string | undefined;
}) {
  const haySoloUna = categoriasScope.length === 1;
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Group justify="space-between" align="flex-start">
          <div>
            <Heading order={5}>Filtros</Heading>
            <Text size="sm" c="dimmed" className="mt-0.5">
              Filtrado y paginado en el servidor · cada operación queda
              registrada en la misma transacción que la mutación.
            </Text>
          </div>
          <BotonExportCambiosCsv
            categoria={filtroCategoriaBackend}
            top={1000}
            habilitado={haySoloUna || !!categoria}
          />
        </Group>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <Select
            label="Categoría"
            options={
              haySoloUna
                ? [{ value: "", label: categoriasScope[0] }]
                : [{ value: "", label: "Todas" }, ...categoriasScope.map((c) => ({ value: c, label: c }))]
            }
            value={categoria}
            onValueChange={onCategoriaChange}
            disabled={haySoloUna}
          />
          <Select
            label="Acción"
            options={[{ value: "", label: "Todas" }, ...accionesDisponibles.map((a) => ({ value: a, label: a }))]}
            value={accion}
            onValueChange={onAccionChange}
            searchable
          />
          <Input
            label="Buscar entidad"
            placeholder="ej. BMI o ACME"
            leftSection={<IconSearch size={14} stroke={1.7} />}
            value={texto}
            onChange={(e) => onTextoChange(e.currentTarget.value)}
          />
        </div>
        <Text size="xs" c="dimmed">
          {total === 0
            ? "Sin eventos para los filtros."
            : `Mostrando ${desde}–${hasta} de ${total} eventos.`}
        </Text>
      </Stack>
    </Card>
  );
}
